import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { IPoolGame } from '../pool-game.interface';
import { PoolGameCoreService } from '../pool-game-core.service';

@Component({
  selector: 'app-pool-game-selector',
  templateUrl: './pool-game-selector.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => PoolGameSelectorComponent),
    },
  ],
})
export class PoolGameSelectorComponent
  implements OnInit, OnDestroy, ControlValueAccessor
{
  private _unsubscribe$ = new Subject<void>();

  @Input()
  hint = '';

  @Input()
  isEmptySelectable = false;

  @Output() itemSelected = new EventEmitter<IPoolGame>();

  ctrl: FormControl = new FormControl();

  constructor(public poolGameCoreService: PoolGameCoreService) {}

  ngOnInit(): void {
    this.ctrl.valueChanges
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe((value: string) => {
        this.itemSelected.emit();
        this.onChange(value);
      });
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChange: any = (): void => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onTouch: any = (): void => {};

  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }

  writeValue(v: string): void {
    this.ctrl.setValue(v);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.ctrl.disable();
    } else {
      this.ctrl.enable();
    }
  }

  refresh(): void {
    this.poolGameCoreService.refresh(true);
  }
}
